import { createAsyncThunk } from '@reduxjs/toolkit';

import { PolicyDataBuilderOptions, selectPolicyData } from '../selectors/selectPolicyData';
import { premiumsApi } from '../services/premiums';
import { updatePremiums } from '../slices/quote';
import { RootState } from '../store';
import { PolicyResponse } from '../types/policy';
import { handleError } from './error';

export const quotePremiumsAction = createAsyncThunk<
  PolicyResponse | undefined,
  PolicyDataBuilderOptions | undefined,
  { state: RootState }
>('quotePremiums', async (options, { getState, dispatch }) => {
  const premiumRequestData = selectPolicyData(getState(), options);
  const response = await dispatch(premiumsApi.endpoints.quotePremiums.initiate(premiumRequestData));
  if ('error' in response) {
    await dispatch(handleError(response.error));
    return Promise.reject(response.error);
  }
  dispatch(updatePremiums(response.data));
  return response.data;
});
